if (document.location.hostname === 'localhost') {
  window._y010 = true;
}

import gsap from "gsap";

import AxL from "./axl.js";
import HaikuThree from './HaikuThree.js';
import LetterSplitter from './LetterSplitter.js';

window.axl = null;
window.AxLHandshaked = false;

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const poem_files = {
  "stream" : {
    index : 15,
    video : "stream-moon-esr.mp4",
    cutout : "moon",
    style : "modern"
  },
  "sword" :
      {index : 14, video : "sword-esr.mp4", cutout : "sword", style : "modern"},
  "river" : {
    index : 13,
    video : "river-snow-esr.mp4",
    cutout : "snowflake",
    style : "traditional"
  },
  "heron" : {
    index : 12,
    video : "birds_snow.mp4",
    cutout : "heron",
    style : "traditional"
  },
  "cemetery" : {
    index : 9,
    video : "cemetery-esr.mp4",
    cutout : "firefly",
    style : "traditional"
  },
  "love" : {
    index : 10,
    video : "willows-stars-esr.mp4",
    cutout : "willow",
    style : "modern"
  },
  "crow" : {
    index : 8,
    video : "crow-branch-esr.mp4",
    cutout : "crow",
    style : "traditional"
  },
  "wind" : {
    index : 11,
    video : "field-birds-esr.mp4",
    cutout : "sing",
    style : "modern"
  },
  "pond" : {
    index : 4,
    video : "pond-esr.mp4",
    cutout : "pond",
    style : "traditional"
  },
  "rain-pine" : {
    index : 5,
    video : "rain-moon-esr.mp4",
    cutout : "gray_rain",
    style : "traditional"
  },
  "poppies" : {
    index : 6,
    video : "poppies-esr.mp4",
    cutout : "poppies",
    style : "modern"
  },
  "moods" :
      {index : 7, video : "rose-esr.mp4", cutout : "rose", style : "modern"},
  "iris" : {
    index : 0,
    video : "iris-esr.mp4",
    cutout : "iris",
    style : "traditional"
  },
  "cold-flower" : {
    index : 2,
    video : "cold-flowers-esr.mp4",
    cutout : "flower",
    style : "modern"
  },
  "spider" : {
    index : 3,
    video : "spiderweb-esr.mp4",
    cutout : "shadow",
    style : "modern"
  },
  "well" : {
    index : 1,
    video : "morningglory-esr.mp4",
    cutout : "morningglory2",
    style : "traditional"
  }
};

const icon_labels = [
  "dream",    "iris",      "bucket",  "morning glory", "morning", "flowers",
  "shadow",   "web",       "pond",    "water",         "rain",    "pines",
  "poppies",  "thunder",   "rose",    "leaves",        "branch",  "crow",
  "cemetery", "fireflies", "willows", "stars",         "fields",  "sing",
  "heron",    "snow",      "river",   "snow",          "stars",   "sword",
  "earth",    "moon"
];

export default class App {
  constructor() {

    this.muted = false;
    this.beforeFreezeStates = {};

    window.axl = new AxL();

    window.axl.registerMessageCallback(
        AxL.HostToChild.FREEZE, function() { this.doFreeze(); }.bind(this));

    window.axl.registerMessageCallback(
        AxL.HostToChild.RESUME, function() { this.doResume(); }.bind(this));

    window.axl.handshake().then((data) => {
      window.AxLHandshaked = true;
      this.init();
    });

    // // if (document.location.hostname === 'localhost') {
    //this.init();
    // // }
  }

  //------initializers
  async init() {

    this.lang = "en";

    // get initial data and sort
    this.poemsData =
        await this.loadJSONData('/haiku-visualization/assets/data/poems.json');
    this.poemsData.poems.forEach(
        (item, i) => { item.index = poem_files[item.key].index; });
    let compare = function(a, b) {
      if (a.index < b.index) {
        return -1;
      }
      if (a.index > b.index) {
        return 1;
      }
      return 0;
    };
    this.poemsData.poems.sort(compare);

    // set all the ui text
    this.uiTexts = await this.loadJSONData(
        '/haiku-visualization/assets/data/haiku_ui.json');
    this.setUiTexts();

    this.letterSplitter = new LetterSplitter();

    // check if we are jumping into a poem (not working)
    if (this.urlIndex == null) {
      // show the intro page
      this.setStartScreenLoadingTextAndAnimation();
      document.getElementById("startscreen").classList.add("show");
    }

    // set credits text, info page
    this.setCredits(this.poemsData['project-details']);
    this.setHaikuInfo(this.poemsData['project-details']);

    // set defailt lang button
    document.getElementById('lang-button').innerText = "[ jp ]";

    // init three world and load grid
    this.world = new HaikuThree(poem_files, this.poemsData);
    this.world.initThreeScene();
    this.world.initThreeNavGrid();

    // init ui listeners
    this.initUiEventListeners();

    if (this.urlIndex != null) {
      this.showPoemLoading(0);
    }
  }

  async loadJSONData(filepath) {
    // const filepath = '/haiku-visualization/assets/data/poems.json';
    const response = await fetch(filepath);
    const json = await response.json();
    console.log(json);
    return json;
  }

  // for the share image
  async imageUrlToBase64(path) {
    const response = await fetch(path);
    const blob = await response.blob();
    return new Promise((onSuccess, onError) => {
      try {
        const reader = new FileReader();
        reader.onload = function() { onSuccess(this.result) };
        reader.readAsDataURL(blob);
      } catch (e) {
        onError(e);
      }
    });
  }

  getBase64StringFromDataURL(dataURL) {
    return dataURL.replace('data:', '').replace(/^.+,/, '');
  }

  setUiTexts() {

    document.getElementById("start-button").innerText =
        this.uiTexts["start-button"];

    document.getElementById("start-screen-loading").innerText =
        this.uiTexts["start-screen-loading"];

    document.getElementById("return-to-poem-label").innerText =
        this.uiTexts["return-to-poem-label"];

    document.getElementById("traditional-label").innerText =
        this.uiTexts["traditional-label"];

    document.getElementById("modern-label").innerText =
        this.uiTexts["modern-label"];

    document.getElementById("haiku-info-button").innerText =
        this.uiTexts["haiku-info-button"];

    let seasons = document.querySelectorAll('.season');
    seasons.forEach(
        (item, i) => { item.innerText = this.uiTexts["nav-grid-seasons"][i]; });

    let startscreentext = document.querySelectorAll('#startscreen-text p');
    startscreentext.forEach(
        (item, i) => { item.innerHTML = this.uiTexts["startscreen-text"][i]; });

    // let startscreentextEl =
    //     document.querySelector("#startscreen-text p:last-child");
    // startscreentextEl.innerHTML +=
    //     "<img src='/haiku-visualization/assets/images/volume_mute.svg' />";

    let backButtons = document.querySelectorAll(".back-button");
    backButtons.forEach((item, i) => { item.innerText = "[ close ]"; });

    document.getElementById("loading-poem-message").innerText =
        this.uiTexts["loading-poem-message"];

    document.getElementById("click-to-begin").innerText =
        this.uiTexts["click-to-begin"];
  }

  setCredits(details) {

    document.getElementById("tools").innerHTML = details.tools.text;

    let el = document.getElementById("project-credits");
    el.innerHTML = details.credits.text;
    setTimeout(function() {
      let atags = document.querySelectorAll("#credits span");
      atags.forEach((item, i) => {
        let url = item.getAttribute("href");
        if (url) {
          item.removeAttribute("href");
          item.classList.add('clickable');
          item.addEventListener("click", function() {
            window.axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);
          });
        }

        if (item.classList.contains('cs')) {
          item.addEventListener(
              'click',
              function() { this.updateBGGradients('rainbow'); }.bind(this));
        }
      });
    }.bind(this), 100);
  }

  setHaikuInfo(details) {
    document.getElementById("haiku-info-text").innerHTML = details.haiku.text;
    setTimeout(function() {
      let atags = document.querySelectorAll("#haiku-info span");
      atags.forEach((item, i) => {
        let url = item.getAttribute("href");
        item.removeAttribute("href");
        item.classList.add('clickable');
        item.addEventListener("click", function() {
          window.axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);
        });
      });
    }, 100);
  }

  //-- events
  initUiEventListeners() {

    window.addEventListener('resize', this.onResize.bind(this), false);

    this.world.initEventListeners();

    // window.addEventListener("keypress",
    //                         function(e) { this.keyPress(e); }.bind(this));

    document.getElementById("start-button").addEventListener('click', function(e) {
      this.startExperience();

      //  check if this works on ios
      let path =
          '/haiku-visualization/' +
          this.poemsData['project-details']['grid_audio']; // assets/audio/grid-audio-quiet-whoosh23-2.mp3';
      this.world.preLoadAudio(path);
    }.bind(this));

    document.getElementById("grid-nav-button")
        .addEventListener('click', function(e) {
          // this.toggleAcvtiveNav(e.currentTarget);
          this.world.gotoGrid();
          clearTimeout(this.showPoetByNameTM);
          clearTimeout(this.showHaikuTM);
          document.getElementById("grid-nav-button-container")
              .classList.remove("show");

          window.axl.sendMessage(AxL.ChildToHost.TRACK,
                                 {action : 'click_grid_icon'});
        }.bind(this));

    document.getElementById("mute-button")
        .addEventListener('click',
                          function(e) { this.toggleMute(); }.bind(this));

    document.getElementById("share-button")
        .addEventListener('click', function(e) { this.doShare(); }.bind(this));

    document.getElementById("more-button")
        .addEventListener('click',
                          function(e) { this.world.gotoAbout(); }.bind(this));

    document.getElementById("poem-word-back-container")
        .addEventListener('click',
                          function(e) { this.world.gotoVideo(); }.bind(this));

    document.getElementById("haiku-poet-name")
        .addEventListener('click',
                          function(e) { this.world.gotoBio(); }.bind(this));

    document.getElementById("poet-name").addEventListener('click', function(e) {
      // TODO: this is a problem for teh source link in the bio
      this.world.leavePoetBio();
    }.bind(this));

    document.getElementById("nav-next-button")
        .addEventListener('click', function(e) {
          document.getElementById("grid-nav-button-container")
              .classList.remove("show");
          this.world.gotoNextPoem();
          window.axl.sendMessage(AxL.ChildToHost.TRACK, {
            action : 'poem_arrow',
            label : 'next',
            value : this.world.currentGridIndex
          });
        }.bind(this));

    document.getElementById("nav-prev-button")
        .addEventListener('click', function(e) {
          document.getElementById("grid-nav-button-container")
              .classList.remove("show");
          this.world.gotoPrevPoem();

          window.axl.sendMessage(AxL.ChildToHost.TRACK, {
            action : 'poem_arrow',
            label : 'prev',
            value : this.world.currentGridIndex
          });
        }.bind(this));

    document.getElementById("haiku-info-back")
        .addEventListener(
            'click',
            function(e) { this.world.goBackFromHaikuInfo(); }.bind(this));

    document.getElementById("about-back")
        .addEventListener(
            'click', function(e) { this.world.goBackFromAbout(); }.bind(this));

    document.getElementById("bio-back")
        .addEventListener(
            'click', function(e) { this.world.goBackFromBio(); }.bind(this));

    document.getElementById("lang-button")
        .addEventListener('click',
                          function(e) { this.toggleLanguage(); }.bind(this));

    document.getElementById("haiku-info-button")
        .addEventListener(
            'click', function(e) { this.world.gotoHaikuInfo(); }.bind(this));

    // document.getElementById("poem-facts-button")
    //     .addEventListener(
    //         'click', function(e) { this.world.showPoemFacts(); }.bind(this));

    let poemButtons = document.querySelectorAll(".letter-icon-button");
    poemButtons.forEach((item, i) => {
      item.addEventListener('click', function() {
        this.world.showPoemWordByIndex(i);
        this.world.preLoadAudio('/haiku-visualization/' + this.world.audioPath);
      }.bind(this));
    });

    this.world.on(
        'reset_gradient',
        function(val) { this.updateBGGradients(val.data); }.bind(this));

    this.world.on('click_poem_icon', function(val) {
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'click_poem', value : val.data});
    });

    this.world.on('show_poem', function(val) {
      window.axl.sendMessage(
          AxL.ChildToHost.TRACK,
          {action : 'show_poem', label : val.data.key, value : val.data.index});
    });

    this.world.on('set_url_for_poem',
                  function(val) { this.doSetUrl(val.data); }.bind(this));

    this.world.on('grid-loaded', function() {
      // hide loading
      this.hideStartScreenLoading();
      // document.getElementById("start-screen-loading").classList.add('hide');
    }.bind(this));

    this.world.on('loading_poem_from_url_ready',
                  function() { this.showUrlPoemNeedToClick(); }.bind(this));

    this.world.on('show_poem_loading',
                  function() { this.showPoemLoading(); }.bind(this));

    this.world.on('hide_poem_loading',
                  function() { this.hidePoemLoading(); }.bind(this));

    this.world.on(
        'set_haiku',
        function(val) { this.setInitialPoemTextAndPlay(val.data); }.bind(this));

    this.world.on('show_haiku',
                  function() { this.showHaikuAgain(); }.bind(this));

    this.world.on('hide_haiku', function() { this.hideHaiku(); }.bind(this));

    this.world.on('show_poem_word', function(val) {
      this.showPoemWord();
      this.world.preLoadAudio('/haiku-visualization/' + this.world.audioPath);
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'enter_word', label : val.data});
    }.bind(this));

    this.world.on('hide_poem_word',
                  function() { this.hidePoemWord(); }.bind(this));

    // this.world.on('show_poem_facts',
    //               function(val) { this.showPoemFacts(val.data);
    //               }.bind(this));
    //
    // this.world.on('hide_poem_facts',
    //               function(val) { this.hidePoemFacts(); }.bind(this));

    this.world.on('show_meta', function(val) {
      this.setMetaData(val.data.poemData, val.data.state);
    }.bind(this));

    this.world.on('show_gridnav_ui',
                  function() { this.showGridNavPanel(); }.bind(this));

    this.world.on('hide_grid_view_ui',
                  function() { this.hideHaikuInfoButton(); }.bind(this));

    this.world.on(
        'show_grid_view_ui',
        function(val) { this.showHaikuInfoButton(val.data); }.bind(this));

    this.world.on('close_haiku_info',
                  function() { this.hideHaikuInfoPage(); }.bind(this));

    this.world.on('show_bio', function(val) { this.showBio(); }.bind(this));

    this.world.on('hide_bio', function() { this.hideBio(); }.bind(this));

    this.world.on('show_haiku_info',
                  function(val) { this.showHaikuInfoPage(); }.bind(this));

    this.world.on('hide_haiku_info',
                  function() { this.hideHaikuInfoPage(); }.bind(this));

    this.world.on('show_about', function() { this.showAbout(); }.bind(this));

    this.world.on('close_about', function() { this.hideAbout(); }.bind(this));

    this.world.on('set_poet_bio', function(val) {
      // not being called
      this.setAuthorData(
          val.data.author,
          val.data.bio,
          val.data.source_link,
          val.data.source_name,
      );
    }.bind(this));

    this.world.on('set_by_poet',
                  function(val) { this.setByPoet(val.data); }.bind(this));

    this.world.on('pause_letter_anim', function() {
      if (this.keywordInterval)
        clearInterval(this.keywordInterval);
      console.log("clearInterval");
    }.bind(this));
  }

  //---- startscreen
  setStartScreenLoadingTextAndAnimation() {
    let el = document.getElementById("start-screen-loading");
    let spanArrays = this.letterSplitter.splitElementText(el, {fontSize : 14});
    let tm = gsap.timeline()
    //{delay : .25, repeat : -1, repeatDelay : 3});
    spanArrays.forEach((item, i) => {
      tm.to(item, {opacity : 1, duration : .5}, "<+=.1");
      // let tm2 = gsap.timeline();
      // tm2.to(item, {"y" : -2, duration : .25});
      // tm2.to(item, {"y" : 0, duration : .5, ease : "sine.inOut"});
      // tm.add(tm2, "<+=.1");
    });
  }

  hideStartScreenLoading() {

    if (this.urlIndex != null) {
      this.startFromUrlPoem(this.urlIndex);
    } else {
      let el = document.getElementById("start-screen-loading");
      let spanArrays = document.querySelectorAll("#start-screen-loading span");
      let tm = gsap.timeline({
        onComplete : function() {
          document.getElementById("start-button").classList.add('show');
        }
      })

      spanArrays.forEach((item, i) => {
        tm.to(item, {opacity : 0, duration : .5, overwrite : true}, "<");
      });
    }
  }

  showLoadingOnStartScreen() {}

  statStartScreenButtonAnim() {
    let button = document.getElementById("start-button");
    let spanArray =
        this.letterSplitter.splitElementText(button, {fontSize : 16})

    let tm = gsap.timeline({delay : 2, repeat : -1, repeatDelay : 3});
    spanArray.forEach((item, i) => {
      let tm2 = gsap.timeline();
      tm2.to(item, {"y" : -2, duration : .25});
      tm2.to(item, {"y" : 0, duration : .5, ease : "sine.inOut"});
      tm.add(tm2, "<+=.1");
    });
  }

  startFromUrlPoem(index) {
    // let callback = function() { this.world.startLoadingPoem(index); }.bind(
    //     this);
    // this.hideStartScreen(callback);
    document.getElementById("bg-gradient").classList.add("show");
    document.getElementById("top-nav-container").classList.add("show");

    // this.world.g
    this.world.startLoadingPoemFromUrlParam(index);
  }

  startExperience() {

    this.hideStartScreen(
        function() { this.world.showInitialGridAnimation(); }.bind(this));

    document.getElementById("bg-gradient").classList.add("show");
  }

  hideStartScreen(callback) {
    let title = document.getElementById("startscreen-title");
    let texts = document.querySelectorAll("#startscreen p");
    let button = document.getElementById("startscreen-go");

    let tm = gsap.timeline();
    tm.to(title, {opacity : 0, scale : .9, duration : 1});
    tm.to(texts[0], {opacity : 0, scale : .9, duration : 1}, "<+.1");
    tm.to(texts[1], {opacity : 0, scale : .9, duration : 1}, "<+.1");
    tm.to(button, {
      opacity : 0,
      scale : .8,
      duration : 1,
      onComplete : function() {
        callback();

        document.getElementById("startscreen").classList.add("hide");
        document.getElementById("start-button").classList.remove("show");
        // document.getElementById("more-button").classList.remove("hide");

        document.getElementById("top-nav-container").classList.add("show");
      }.bind(this)
    },
          "<+.1");
  }

  showUrlPoemNeedToClick() {
    this.hidePoemLoadingLetters();
    // add lcicl to begin
    let el = document.getElementById("click-to-begin");
    el.classList.add("show");
  }

  //------ axl
  doSetUrl(index) {
    this.urlIndex = index;
    // window.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {poem : index});
  }

  doFreeze() {
    this.beforeFreezeStates['muted'] = this.muted;

    this.muteAll();

    let video = document.getElementById("haiku-video");
    this.beforeFreezeStates['video_pause'] = video.paused;
    video.pause();

    if (this.world) {
      // this.beforeFreezeStates['audio_pause'] = false;
      // if (!this.world.webAudio.isPlayingSource) {
      //   this.beforeFreezeStates['audio_pause'] = true;
      // }
      // this.world.webAudio.pause();
      //
      this.world.pauseAnimate();
    }
  }

  doResume() {
    if (this.beforeFreezeStates['muted'] == false) {
      this.unMuteAll();
    }

    let video = document.getElementById("haiku-video");
    if (this.beforeFreezeStates['video_pause'] == false) {
      video.play();
    }

    if (this.world) {
      this.world.unpauseAnimate();
    }
  }

  async doShare() {
    // will be null if not in a poem yet
    const index = this.urlIndex;
    window.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {"poem" : index});
    window.axl.sendMessage(AxL.ChildToHost.SHARE, {
      "text" : this.uiTexts["share_text"],
      "title" : this.uiTexts["share_title"]
    });
    window.axl.sendMessage(AxL.ChildToHost.TRACK,
                           {action : 'click_share', value : index});
  }

  //------ ui
  showGridNavPanel() {
    document.getElementById("grid-nav-button-container").classList.add("show");

    // this.showFactsButton();
  }

  hideGridNavPanel() {
    document.getElementById("grid-nav-button-container")
        .classList.remove("show");

    // this.hideFactsButton();
  }

  // showFactsButton() {
  //   let el = document.getElementById("poem-facts-button");
  //   gsap.to(el, {
  //     opacity : .75,
  //     y : -10,
  //     duration : 1,
  //     delay : 1,
  //     onComplete : () => { el.classList.add("show"); }
  //   });
  // }

  // hideFactsButton() {
  //   let el = document.getElementById("poem-facts-button");
  //   gsap.to(el, {
  //     opacity : 0,
  //     y : 0,
  //     duration : 1,
  //     onComplete : () => { el.classList.remove("show"); }
  //   });
  // }

  updateBGGradients(current) {
    console.log("updateBGGradients", current);
    // disable gradients
    // enable current
    document.body.className = "";
    let bgs = document.querySelectorAll(".bg-gradient-item");
    bgs.forEach((item, i) => {
      if (item.id != "bg-gradient-" + current) {
        item.classList.remove("show");
        if (document.body.classList.contains(current) && current.length > 0)
          document.body.classList.remove(current);
      } else {
        item.classList.add("show");
      }
    });

    // document.body.className = "";
    if (current.length > 0)
      document.body.classList.add(current);
  }

  showBio() {

    let bioEl = document.getElementById('poet-bio-container');
    bioEl.classList.add('show');
    gsap.to(bioEl, {'x' : 0, 'y' : 0, 'duration' : 2, 'ease' : 'sine.inOut'});
    this.hideGridNavPanel();
    window.axl.sendMessage(AxL.ChildToHost.TRACK, {
      action : 'click_author',
      label : this.poemData.name,
      value : this.urlIndex
    });
  }

  hideBio() {

    let bioEl = document.getElementById('poet-bio-container');

    gsap.to(bioEl, {
      'x' : "-100vw",
      'duration' : 2,
      'ease' : 'sine.inOut',
      'overwrite' : true,
      'onComplete' : () => { bioEl.classList.remove('show'); }
    });
  }

  showAbout() {
    // document.getElementById('about-container').classList.add('show');
    document.getElementById('credits-container').classList.add('show');
    let credits = document.getElementById('credits');
    gsap.to(credits, {'y' : 0, duration : 2, 'ease' : 'sine.inOut'});
    this.hideGridNavPanel();
    window.axl.sendMessage(AxL.ChildToHost.TRACK, {action : 'click_credits'});
  }

  hideAbout() {
    // document.getElementById('credits-container').classList.remove('show');
    let credits = document.getElementById('credits');
    gsap.to(credits, {
      y : '-100vh',
      duration : 2,
      'ease' : 'sine.inOut',
      onComplete : function() {
        // document.getElementById('about-container').classList.remove('show');
      }
    });

    // document.getElementById('about-container').classList.remove('show');
  }

  showHaikuInfoPage() {
    document.getElementById('haiku-info-container').classList.add('show');
    let el = document.getElementById('haiku-info');
    gsap.to(el, {'y' : 0, duration : 2, 'ease' : 'sine.inOut'});
    window.axl.sendMessage(AxL.ChildToHost.TRACK,
                           {action : 'click_haiku_info'});
  }

  hideHaikuInfoPage() {
    // document.getElementById('haiku-info-container').classList.remove('show');
    let el = document.getElementById('haiku-info');
    gsap.to(el, {
      y : '100vh',
      duration : 2,
      'ease' : 'sine.inOut',
      onComplete : function() { el.classList.remove('show'); }
    });
  }

  hideHaikuInfoButton() {
    let haikuInfoButton = document.getElementById("haiku-info-button");
    haikuInfoButton.classList.remove("show");
    gsap.to(haikuInfoButton, {
      opacity : 0,
      y : 0,
      duration : 1,
      ease : 'sine.inOut',
      overwrite : true
    });
  }

  showHaikuInfoButton(delay = 0) {
    let haikuInfoButton = document.getElementById("haiku-info-button");
    gsap.to(haikuInfoButton, {
      opacity : 1,
      y : -10,
      duration : 1,
      ease : 'sine.inOut',
      delay : delay,
      onComplete : () => { haikuInfoButton.classList.add("show") }
    });
  }

  showPoemLoading(delay = 1.5) {
    let loadingEl = document.getElementById("loading-container");
    loadingEl.classList.add("show");

    let loadingText = document.getElementById("loading-poem-message");

    if (!this.loadingTM) {
      let fontSize = 14;

      let spanArray =
          this.letterSplitter.splitElementText(loadingText, {fontSize : 14});

      this.loadingTM = gsap.timeline({delay : delay});
      spanArray.forEach((item, i) => {
        let tm = gsap.timeline();
        tm.to(item, {opacity : 1, duration : 1});
        tm.to(item, {y : 5, duration : .5}, "<");
        tm.to(item, {y : 0, duration : 1}, "<+.5");
        this.loadingTM.add(tm, "<+=.1")
      });

    } else {
      this.loadingTM.restart({includeDelay : true});
    }
  }

  hidePoemLoading() {
    let loadingEl = document.getElementById("loading-container");
    loadingEl.classList.remove("show");

    this.hidePoemLoadingLetters();

    let el = document.getElementById("click-to-begin");
    el.classList.remove("show");
    // let loadingText = document.getElementById("loading-poem-message");
    // gsap.to(loadingText, {opacity : 0, duration : 1, delay : 0});
  }

  hidePoemLoadingLetters() {
    if (!this.hideLoadingTM) {
      let spanArray = document.querySelectorAll("#loading-poem-message span");
      this.hideLoadingTM = gsap.timeline();
      spanArray.forEach((item, i) => {
        this.hideLoadingTM.to(item, {opacity : 0, duration : 1}, "<+=.1");
      });

    } else {
      this.hideLoadingTM.restart();
    }
  }

  toggleLanguage() {
    let el = document.getElementById('lang-button');
    if (!this.lang) {
      this.lang = "en";
    }
    if (this.lang == "en") {
      this.lang = "jp";
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'lang_toggle', label : 'jp'});
      this.showJapaneseVersion();
    } else {
      this.lang = "en";
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'lang_toggle', label : 'en'});
      this.showEnglishVersion();
    }
  }

  showSwapLanguage(lang) {
    let poemData = this.poemData;
    if (poemData['japanese'].length <= 0)
      return;

    if (this.keywordInterval)
      clearInterval(this.keywordInterval);

    if (this.JPTM)
      clearTimeout(this.JPTM);

    let myLetters = document.querySelectorAll("#words span.anim");
    myLetters.forEach((item, i) => {
      let tm = gsap.timeline();

      tm.to(
          item,
          {opacity : 0, duration : .5, ease : 'sine.inOut', overwrite : true});
      tm.to(item, {
        x : (Math.random() - .25) * 500,
        y : -200 - Math.random() * 200,
        rotation : Math.random() * 360,
        duration : 1.9,
        ease : 'sine.inOut'
      },
            "<");
    });

    this.hidePoemPoetLangButtons();

    this.JPTM = setTimeout(function() {
      if (lang == 'jp')
        document.getElementById('lang-button').innerText = "[ en ]";
      else {
        document.getElementById('lang-button').innerText = "[ jp ]";
      }
      this.setByPoet(poemData.author, lang);
      this.setPoemLetters(poemData, lang);
      this.startPoemJP();
      if (lang == 'en') {
        let season = this.poemData.season;
        this.beginAnimKeywords(season);
      }
    }.bind(this), 1200);
  }

  showJapaneseVersion() { this.showSwapLanguage('jp'); }

  showEnglishVersion() { this.showSwapLanguage('en'); }

  showPoemWord() {
    // this.toggleAcvtiveNav(null);
    this.showGridNavPanel();
    this.showPoemWordTM = setTimeout(function() {
      document.getElementById("poem-word-back-container").classList.add('show');
    }, 2000);

    document.getElementById("words").style.zIndex = 0;
  }

  hidePoemWord() {
    if (this.showPoemWordTM)
      clearTimeout(this.showPoemWordTM);
    document.getElementById("poem-word-back-container")
        .classList.remove('show');
    setTimeout(
        function() { document.getElementById("words").style.zIndex = 2; },
        4000);
  }

  // showPoemFacts(delay = 0) {
  //   let facts_container = document.getElementById("poem-facts-container");
  //   facts_container.classList.add("show");
  //   let topEl = document.getElementById("poem-facts-top");
  //   let botEl = document.getElementById("poem-facts-bottom");
  //   gsap.to(topEl, {opacity : 1, duration : 1, delay : delay});
  //   gsap.to(botEl, {opacity : 1, duration : 1, delay : delay + .2});
  //
  //   this.showPoemWordTM = setTimeout(function() {
  //     document.getElementById("poem-word-back-container").classList.add('show');
  //   }, 2000);
  // }
  //
  // hidePoemFacts(delay = 0) {
  //   let facts_container = document.getElementById("poem-facts-container");
  //   let topEl = document.getElementById("poem-facts-top");
  //   let botEl = document.getElementById("poem-facts-bottom");
  //   gsap.to(botEl, {opacity : 0, duration : 1, delay : delay});
  //   gsap.to(topEl, {
  //     opacity : 0,
  //     duration : 1,
  //     delay : delay + .2,
  //     onComplete : () => { facts_container.classList.remove("show"); }
  //   });
  //   document.getElementById("poem-word-back-container")
  //       .classList.remove('show');
  // }

  showPoemButtons(delay) {
    document.getElementById("letter-icon-buttons").classList.add("show");
    let iconButtons = document.querySelectorAll('.letter-icon-button');
    let index = this.urlIndex * 2;
    iconButtons.forEach((item, i) => {
      item.style.backgroundImage =
          "url('/haiku-visualization/assets/cutouts_small/cutout_small_" +
          (index + i) + ".png')";
      item.setAttribute('aria-label',
                        'audio for word ' + icon_labels[index + i]);
      gsap.to(item, {y : -10, duration : .25, delay : delay + (i * .1)});
      gsap.to(item, {opacity : 1, duration : 1, delay : delay});
    });
  }

  hidePoemPoetLangButtons() {
    document.getElementById("haiku-poet-name").classList.remove("show");
    document.getElementById("lang-button").classList.remove("show");
    document.getElementById("jp-en").classList.remove("show");

    let iconButtons = document.querySelectorAll('.letter-icon-button');
    iconButtons.forEach((item, i) => {
      gsap.to(item, {
        opacity : 0,
        y : 0,
        duration : 1,
        overwrite : true,
        onComplete : () => {
          document.getElementById("letter-icon-buttons")
              .classList.remove("show");
        }
      });
    });
  }

  toggleAcvtiveNav(activeEl) {
    let navBarItems =
        document.querySelectorAll('#grid-nav-button-container button');
    navBarItems.forEach((item, i) => { item.classList.remove("active"); });
    if (activeEl)
      activeEl.classList.add("active");
  }

  onResize() { this.resetLettersForAnim(); }

  //------ set values
  // sets abs positioned letters to be animated (original letters keep the
  // formatting)
  resetLettersForAnim() {
    let container = document.getElementById("words");
    container.classList.remove("persp");

    let currentAnimLetters = document.querySelectorAll("span.anim");
    let originalLetters = document.querySelectorAll("#words span:not(.anim)");
    currentAnimLetters.forEach((letter, i) => {
      let parent = originalLetters[i];
      letter.style.left = (parent.getBoundingClientRect().x -
                           container.getBoundingClientRect().x) +
                          "px";
      letter.style.top = (parent.getBoundingClientRect().y -
                          container.getBoundingClientRect().y) +
                         "px";
    });
    container.classList.add("persp");
  }

  // sets duplicate letters for the poem (for animation)
  setPoemLettersForAnim() {

    let container = document.getElementById("words");
    container.classList.remove("persp");

    let currentAnimLetters = document.querySelectorAll("span.anim");
    currentAnimLetters.forEach((letter, i) => { letter.remove(); });

    for (let i = 0; i < 3; i++) {
      let parent = document.getElementById("words-line-" + (i + 1));
      let newElems = [];
      for (const child of parent.children) {
        let letter = child.innerText;

        let spanA = document.createElement("span");
        spanA.style.position = "absolute";
        spanA.style.left = (child.getBoundingClientRect().x -
                            container.getBoundingClientRect().x) +
                           "px";
        spanA.style.top = (child.getBoundingClientRect().y -
                           container.getBoundingClientRect().y) +
                          "px";
        spanA.innerText = letter;
        spanA.classList.add("anim");
        spanA.style.opacity = 0;
        if (child.classList.contains("keyword")) {
          spanA.classList.add("keyword");
          spanA.setAttribute('data-word', child.getAttribute('data-word'));
          spanA.addEventListener('click', function(e) {
            let word = e.target.getAttribute('data-word');
            this.world.showPoemWord(word);
            this.world.preLoadAudio('/haiku-visualization/' +
                                    this.world.audioPath);
          }.bind(this));
        }

        newElems.push(spanA);
      }
      newElems.forEach((item, i) => { parent.appendChild(item); });
    }
    container.classList.add("persp");
  }

  setInitialPoemTextAndPlay(poemData, lang = 'en') {
    this.lang = lang;
    document.getElementById('lang-button').innerText = "[ jp ]";
    this.setPoemLetters(poemData, lang);
    this.startPoemAnimateIn();
  }

  // setFacts(poemData) {
  //   let catEl = document.getElementById("poem-facts-cat");
  //   let factEl = document.getElementById("poem-facts-fact");
  //
  //   let season = poemData.season;
  //   let style = poem_files[poemData.key].style;
  //   catEl.innerText = season + " | " + style;
  //   factEl.innerText = poemData.about;
  // }

  // set the html text for the poem and animates in
  setPoemLetters(poemData, lang) {

    this.poemData = poemData;

    // turn off perspective
    document.getElementById("words").classList.remove("persp");

    // remove animations
    let poem_text = poemData.english;
    if (lang == "jp")
      poem_text = poemData.japanese;

    document.getElementById("words").classList.remove("fall");

    // remove past poem
    let word_line_els = document.querySelectorAll('.word-line');
    word_line_els.forEach((el, i) => { el.innerHTML = ""; });
    // replaceChildren(); });

    // clear previous animations
    if (this.showHaikuTM)
      clearTimeout(this.showHaikuTM);
    if (this.showPoetByNameTM)
      clearTimeout(this.showPoetByNameTM);

    // split poem by lines
    let lines = poem_text.split('\n');

    lines.forEach((item, i) => {
      // find the keywords in each
      let keywordIndices = [];
      let keywordLookUp = {};
      poemData.word_assets.forEach((word_asset, i) => {
        let word = word_asset.word;
        let lowercaseLine = item.toLowerCase();
        let word_index = lowercaseLine.indexOf(word);
        if (word_index !== -1) {
          for (let l = word_index; l < word_index + word.length; l++) {
            keywordIndices.push(l);
            keywordLookUp[l] = word;
          }
        }
      });

      // create each letter in individual span tag
      let myLetters = item.split("");
      let parent = document.getElementById("words-line-" + (i + 1));
      myLetters.forEach((item, i) => {
        let span = document.createElement("span");
        span.innerText = item;
        if (keywordIndices.includes(i)) {
          span.classList.add("keyword");
          span.setAttribute('data-word', keywordLookUp[i]);
          span.addEventListener('click', function(e) {
            let word = e.target.getAttribute('data-word');
            this.world.showPoemWord(word);
          }.bind(this));
        }
        parent.appendChild(span);
      });
    });

    // set the duplicate letters for animating
    setTimeout(function() { this.setPoemLettersForAnim(); }.bind(this), 100);
  }

  startPoemAnimateIn() {
    // fade in everything
    this.showHaikuTM = setTimeout(function() {
      let myLetters = document.querySelectorAll("#words span.anim");
      // myLetters.forEach((item, i) => {
      //   setTimeout(function() { item.classList.add("show"); }, i * 75);
      // });
      this.animeInLetters(.075);

      this.showPoetByNameTM = setTimeout(function() {
        document.getElementById("haiku-poet-name").classList.add("show");
        this.showLang('jp');
        this.showPoemButtons(1);
      }.bind(this), (myLetters.length * 75) + 500);

      let season = this.poemData.season;
      this.beginAnimKeywords(season);
    }.bind(this), 3000);
  }

  startPoemJP() {

    this.showHaikuTM = setTimeout(function() {
      let myLetters = document.querySelectorAll("#words span.anim");

      this.animeInLetters(.05);

      this.showPoetByNameTM = setTimeout(function() {
        document.getElementById("haiku-poet-name").classList.add("show");
        this.showLang();
        this.showPoemButtons(1);
      }.bind(this), (myLetters.length * 75) + 500);
    }.bind(this), 100);
  }

  showLang() {
    let lang = this.lang;
    let poemData = this.poemData;

    if (poemData.japanese.length > 0) {
      let langBut = document.getElementById("lang-button");
      langBut.classList.add('show');
      document.getElementById("jp-en").classList.add("show");

    } else {
      let langBut = document.getElementById("lang-button");
      langBut.classList.remove('show');
      document.getElementById("jp-en").classList.remove("show");
    }
  }

  // re-show haiku (after return from bio etc.)
  animeInLetters(letterDelay) {
    let myLetters = document.querySelectorAll("#words span.anim");
    myLetters.forEach((item, i) => {
      let tm = gsap.timeline();
      tm.to(item, {
        x : 0,
        y : 0,
        rotation : 0,
        opacity : 0,
        duration : 0,
        overwrite : true
      });
      tm.to(item, {opacity : 1, delay : (i + 1) * letterDelay, duration : 1});
    });
    document.getElementById("words").classList.remove("disable");
  }

  animeOutLetters() {
    // falling animation
    let myLetters = document.querySelectorAll("#words span.anim");
    myLetters.forEach((item, i) => {
      let tm = gsap.timeline();
      tm.to(item, {opacity : 0, duration : 2, overwrite : true});
      tm.to(item, {
        x : (Math.random() - .5) * 300,
        y : (Math.random() * 100) + 300,
        rotation : (Math.random() - .5) * 360,
        delay : Math.random() * 2,
        duration : 4
      },
            "<");
    });
    document.getElementById("words").classList.add("disable");
  }

  showHaikuAgain() {
    this.showGridNavPanel();

    console.log("show haiku again");

    document.getElementById("words").classList.remove("fall");

    this.animeInLetters(.05);

    let myLetters = document.querySelectorAll("#words span.anim ");
    // myLetters.forEach((item, i) => {
    //   let tm = gsap.timeline();
    //   tm.to(item, {
    //     x : 0,
    //     y : 0,
    //     rotation : 0,
    //     opacity : 0,
    //     duration : 0,
    //     overwrite : true
    //   });
    //   tm.to(item, {opacity : 1, delay : (i + 1) * .1,
    //   duration : 1});
    // item.classList.remove("show");
    // item.showTM =
    //     setTimeout(function() {
    //     item.classList.add("show"); }, (i + 1) * 100);
    // });

    this.showPoetByNameTM = setTimeout(function() {
      document.getElementById("haiku-poet-name").classList.add("show");
      this.showLang('jp');
      this.showPoemButtons(1);
      let season = this.poemData.season;
      this.beginAnimKeywords(season);
    }.bind(this), (myLetters.length * 50) + 500);

    // this.toggleAcvtiveNav(document.getElementById("video-nav-button"));
  }

  // set the poet bio and name
  setAuthorData(poetName, poetBio, bioLink, bioSource) {

    let link = document.createElement('span');
    let spanStart = document.createElement('span');
    spanStart.innerText = '[Source: ';
    let spanEnd = document.createElement('span');
    spanEnd.innerText = ' ]';
    link.innerText = bioSource;
    if (bioLink) {
      link.classList.add('clickable');
      link.addEventListener('click', function() {
        window.axl.sendMessage(AxL.ChildToHost.NAVIGATE, bioLink);
      }.bind(this));
    }

    let bioEl = document.getElementById('bio-source');
    bioEl.innerHTML = "";
    bioEl.appendChild(spanStart);
    bioEl.appendChild(link);
    bioEl.appendChild(spanEnd);

    document.getElementById('poet-name').innerText = poetName;
    document.getElementById('poet-bio-text').innerText = poetBio;

    //
  }

  // set the poet name on the main haiku view
  setByPoet(poetName, lang = "en") {
    if (lang == 'en')
      document.getElementById("haiku-poet-name").innerText = "by " + poetName;
    else
      document.getElementById("haiku-poet-name").innerText = poetName;
  }

  hideHaiku() {
    console.log("hide haiku");
    if (this.showHaikuTM)
      clearTimeout(this.showHaikuTM);
    if (this.showPoetByNameTM)
      clearTimeout(this.showPoetByNameTM);
    if (this.keywordInterval)
      clearInterval(this.keywordInterval);

    // document.getElementById("words").classList.add("fall");
    this.animeOutLetters();
    this.hidePoemPoetLangButtons();

    let currentAnimLetters = document.querySelectorAll("span.anim.keyword");
    currentAnimLetters.forEach((letter, i) => {
      // letter.classList.remove("show");
      if (letter.tween) {
        letter.tween.kill();
      }
    });

    let myLetters = document.querySelectorAll("#words span.anim");
    myLetters.forEach((item, i) => {
      // item.classList.remove("show");
      if (item.showTM)
        clearTimeout(item.showTM);
    });
  }

  setMetaData(poemData, state) {
    return;
    if (poemData == null) {
      document.getElementById("poem-meta-container").classList.remove("show");
      return;
    }

    let season = poemData.season;
    let style = poem_files[poemData.key].style; //"traditional";
    if (state == "show_poem") {
      // document.getElementById("ai-meta-container").innerText = "video:
      // Phenaki";
      document.getElementById("style-meta-container").innerText =
          season + " | " + style;
      document.getElementById("poem-meta-container").classList.add("show");
    } else if (state == "show_poem_word") {
      document.getElementById("style-meta-container").innerText =
          season + " | " + style;
      // document.getElementById("ai-meta-container").innerText =
      //     "music: Music LM, type: Parti";
      document.getElementById("poem-meta-container").classList.add("show");
    } else {
      document.getElementById("poem-meta-container").classList.remove("show");
    }
  }

  //------ interactions

  toggleMute() {
    if (this.muted) {
      this.muted = false;
      document.getElementById("mute-button").classList.remove("muted");
    } else {
      this.muted = true;
      document.getElementById("mute-button").classList.add("muted");
    }
    if (this.muted == true) {
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'toggle_volume', label : 'mute'});
      this.world.webAudio.mute();
    } else {
      window.axl.sendMessage(AxL.ChildToHost.TRACK,
                             {action : 'toggle_volume', label : 'on'});
      this.world.webAudio.unmute();
    }
    document.getElementById("haiku-video").muted = this.muted;
  }

  muteAll() {
    this.muted = true;
    document.getElementById("mute-button").classList.add("muted");
    document.getElementById("haiku-video").muted = true;
    if (this.world) {
      this.world.webAudio.mute();
    }
  }

  unMuteAll() {
    this.muted = false;
    document.getElementById("mute-button").classList.remove("muted");
    document.getElementById("haiku-video").muted = false;
    if (this.world) {
      this.world.webAudio.unmute();
    }
  }

  //------ keyword animations
  beginAnimKeywords(season) {

    if (this.keywordInterval) {
      clearInterval(this.keywordInterval);
    }
    let intervalTime = 8;

    switch (season) {
    case 'winter':
      this.keywordInterval =
          setInterval(function() { this.beginAnimKeywordsShiver(); }.bind(this),
                      intervalTime * 1000);
      break;
    case 'spring':
      this.keywordInterval =
          setInterval(function() { this.beginAnimKeywordsBob(); }.bind(this),
                      intervalTime * 1000);
      break;
    case 'summer':
      this.keywordInterval =
          setInterval(function() { this.beginAnimKeywordsPopUp(); }.bind(this),
                      intervalTime * 1000);
      break;
    case 'autumn':
      this.keywordInterval =
          setInterval(function() { this.beginAnimKeywordsWindy(); }.bind(this),
                      intervalTime * 1000);
      break;
    }
  }

  beginAnimKeywordsPopUp() {
    let currentAnimLetters = document.querySelectorAll("span.anim.keyword");
    let word = currentAnimLetters[0].getAttribute('data-word');
    let delay = 0;
    currentAnimLetters.forEach((letter, i) => {
      if (letter.tween) {
        letter.tween.kill();
      }

      if (letter.getAttribute('data-word') != word) {
        word = letter.getAttribute('data-word');
        delay += 2;
      }
      letter.tween = gsap.to(letter, {
        y : -5,
        duration : .25,
        delay : delay + (i * .15),
        ease : 'sine.out',
        onComplete : function() {
          gsap.to(letter, {y : 0, duration : .5, ease : 'sine.inOut'});
        }
      });
    });
  }

  beginAnimKeywordsShiver() {
    let currentAnimLetters = document.querySelectorAll("span.anim.keyword");
    let word = currentAnimLetters[0].getAttribute('data-word');
    let delay = 0;
    currentAnimLetters.forEach((letter, i) => {
      if (letter.getAttribute('data-word') != word) {
        word = letter.getAttribute('data-word');
        delay += 2;
      }
      if (letter.tween) {
        letter.tween.kill();
      }
      letter.tween = gsap.to(letter, {
        x : 1,
        duration : .1,
        delay : delay + (i * .15),
        repeat : 10,
        onComplete : function() { gsap.to(letter, {x : 0, duration : .1}) }
      });
    });
  }

  beginAnimKeywordsWindy() {
    let currentAnimLetters = document.querySelectorAll("span.anim.keyword");
    let word = currentAnimLetters[0].getAttribute('data-word');
    let delay = 0;
    currentAnimLetters.forEach((letter, i) => {
      if (letter.getAttribute('data-word') != word) {
        word = letter.getAttribute('data-word');
        // delay += 2;
      }
      if (letter.tween) {
        letter.tween.kill();
      }
      letter.tween = gsap.to(letter, {
        x : (Math.random() - .25) * 10,
        y : -Math.random() * 10,
        rotation : (Math.random() - .5) * 90,
        duration : .5,
        delay : delay + (i * .05),
        ease : 'sine.out',
        onComplete : function() {
          gsap.to(
              letter,
              {x : 0, y : 0, rotation : 0, duration : 2, ease : 'sine.inOut'})
        }
      });
    });
  }

  beginAnimKeywordsBob() {
    let currentAnimLetters = document.querySelectorAll("span.anim.keyword");
    let word = currentAnimLetters[0].getAttribute('data-word');
    let delay = 0;
    currentAnimLetters.forEach((letter, i) => {
      if (letter.getAttribute('data-word') != word) {
        word = letter.getAttribute('data-word');
        delay += 2;
      }
      if (letter.tween) {
        letter.tween.kill();
      }
      if (letter.tl) {
        letter.tl.kill();
      }

      letter.tl = gsap.timeline();
      letter.tl.to(letter, {
        y : Math.random() * 8,
        rotation : (Math.random() - .5) * 10,
        duration : .75,
        ease : 'sine.inOut'
      });
      letter.tl.to(letter, {
        y : Math.random() * 8,
        rotation : (Math.random() - .5) * 10,
        duration : .75,
        ease : 'sine.inOut'
      });
      letter.tl.to(letter, {
        y : Math.random() * 8,
        rotation : (Math.random() - .5) * 10,
        duration : .75,
        ease : 'sine.inOut'
      });
      letter.tl.to(letter,
                   {y : 0, rotation : 0, duration : .75, ease : 'sine.inOut'});
    });
  }

  //------
  keyPress(e) { this.world.keyPress(e); }
}
